// 🫆 **바이트 SHA-256 hex — 도메인 중립 정본**(EF `sha256Hex` 의 브라우저판).
//
// ★왜 별도 모듈인가(적대 리뷰 P3-③)★: 이 산식의 소비처는 두 도메인이다 — ①컴플라이언스 자료
//   업로드(파일 지문) ②합본 렌더의 베드 QC(클립 파형 지문). 산식을 `compliance-library` 에 두면
//   ★렌더가 컴플라이언스 도메인을 import★ 하게 되어(무관한 타입·상수 사슬이 함께 딸려온다) 의존
//   방향이 뒤틀린다. 산식 자체는 어느 도메인의 것도 아니므로 중립 자리에 둔다.
// ★산식은 ★한 벌★ 이다★ — `compliance-library` 는 이 모듈을 재수출만 한다(두 벌이 되면 같은
//   파형이 두 지문을 갖고, 그 순간 저장된 QC 가 전량 재검사 대상이 된다).

/** 바이트 → SHA-256 hex(소문자). `crypto.subtle` 이 없는 문맥(비보안 컨텍스트)에서는 throw 한다 —
 *  호출부가 "지문을 모른다"로 접을지 실패로 볼지 정한다(여기서 단정하지 않는다). */
export async function sha256HexOfBytes(bytes: ArrayBuffer): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

/** 파일 바이트 → SHA-256 hex — 위 바이트판의 얇은 어댑터. */
export async function sha256HexOfFile(file: File): Promise<string> {
  return sha256HexOfBytes(await file.arrayBuffer());
}
